// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".well[data-v-5140bdd6]{width:50%;margin:auto}", ""]);
// Exports
module.exports = exports;
